import axios from "axios";
import {
    ADD_NEW_USER_PROJECT,
    DELETE_USER_PROJECT,
    UPDATE_USER_PROJECT,
} from "./RestCatalog";

const addNewUserProject = (payload) => {
    return axios.post(ADD_NEW_USER_PROJECT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUserProject = (payload) => {
    return axios.post(DELETE_USER_PROJECT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUserProject = (payload) => {
    return axios.post(UPDATE_USER_PROJECT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { addNewUserProject, deleteUserProject, updateUserProject };

